import { jsxs as e, jsx as r } from "react/jsx-runtime";
import t from "@mui/joy/FormLabel";
const l = ({ children: l2, required: o, preview: a, disabled: i, sx: n = {} }) => e(t, { sx: { margin: 0, fontWeight: a ? 400 : 500, fontSize: 14, color: i ? (e2) => e2.palette.isDarkMode ? e2.palette.neutral[500] : e2.palette.neutral[400] : a ? "neutral.700" : "neutral.800", userSelect: "text", ...n }, children: [l2, " ", !a && o && r("span", { style: { color: i ? "neutral.400" : "red" }, children: "*" })] });
export {
  l as FormLabel
};
//# sourceMappingURL=FormLabel.js.map
